export default "__VITE_ASSET__COc_BiIZ__"